<template>
    <v-btn v-bind="{ ...$attrs, loading, disabled }" @click="link">
        <slot />
    </v-btn>
</template>

<script>
import api from "@/api";
import { initManufacturingMaterial } from "@/assets/variables";

export default {
    props: {
        loading: { type: Boolean, default: false },
        material: { type: Object, default: initManufacturingMaterial },
        searchItem: { type: Object, default: () => ({}) },
    },
    computed: {
        disabled() {
            return this.material.links.some((item) => item._vendor == this.searchItem._vendor && item.vendorItemCode == this.searchItem.vendorItemCode);
        },
    },
    methods: {
        async link() {
            if (this.loading) return;
            else this.$emit("setLoading", true);

            try {
                const { _vendor, _material, price, count, stock, vendorCode, vendorItemCode } = this.searchItem;

                const { link } = await api.console.manufacturing.materials.links.post({
                    _vendor,
                    _material,
                    price,
                    count,
                    stock,
                    vendorCode,
                    vendorItemCode,
                    isActive: true,
                });
                this.$emit("setLoading", false);
                this.$emit("updateLinkItem", link);
            } finally {
                if (this.loading) this.$emit("setLoading", false);
            }
        },
    },
};
</script>

<style></style>
